import React from 'react';
import { Loader } from '../Loader';
import { StartSlideV11 } from '../StartSlideV11';
import { StartSlideV19 } from '../StartSlideV19';
import { useABExperiment } from '../../shared/use-ab-experiment';
import styles from './StartSlideV19Experiment.css';

const EXPERIMENT_KEY = 'memory-first-screen-experiment-v53-2-2';
const EXPERIMENT_USER_PROPERTY = 'memory_first_screen_experiment';

function StartSlideV19Experiment(props) {
    const { isReady, isVariant } = useABExperiment({
        key: EXPERIMENT_KEY,
        userPropertyName: EXPERIMENT_USER_PROPERTY
    });

    if (!isReady) {
        return (
            <div className={styles.loaderContainer}>
                <Loader />
            </div>
        );
    }

    if (!isVariant) {
        return <StartSlideV11 {...props} />;
    }

    return <StartSlideV19 {...props} />;
}

export {
    StartSlideV19Experiment
};
